module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/quick1_0c74fc3396a067561f613115b9cbad74.png";